'use strict'

const pick_ = require('lodash/pick')

const getReferencedCollectionsNames = require('./getReferencedCollectionsNames')
const promiseRetry = require('@wix/dbsm-common/src/promiseRetry')

const NUMBER_OF_SCHEMA_RETRIES = 5

const SCHEMA_FETCH_FAILURE_BREADCRUMB = (retry, error) => ({
  category: 'schema',
  message: `LOAD_SCHEMA_FAILURE retry ${retry}/${NUMBER_OF_SCHEMA_RETRIES}`,
  data: { error }
})

const SCHEMA_FETCH_SUCCESS_BREADCRUMB = retry => ({
  category: 'schema',
  message: `LOAD_SCHEMA_SUCCESS after ${retry} retries`
})

module.exports = (wixDataSchemasProxy, logger) => {
  let schemasPromise
  let cachedSchemas = null

  const fetchSchemas = collectionNames => {
    let schemaLoadRetryNum = 1
    const schemasRetryPromise = promiseRetry(
      () =>
        wixDataSchemasProxy
          .bulkGet(collectionNames, { referencedCollectionsDepth: 1 })
          .catch(error => {
            logger.breadcrumb(
              SCHEMA_FETCH_FAILURE_BREADCRUMB(schemaLoadRetryNum, error)
            )
            schemaLoadRetryNum++
            throw error
          }),
      NUMBER_OF_SCHEMA_RETRIES
    )
    return schemasRetryPromise
      .then(schemas => {
        if (schemaLoadRetryNum > 1) {
          logger.error(new Error('Fetching schemas required retries'), {
            level: 'info'
          })
        }
        logger.breadcrumb(SCHEMA_FETCH_SUCCESS_BREADCRUMB(schemaLoadRetryNum))
        logger.addSessionData(() => ({ schemas }))
        cachedSchemas = schemas
        return schemas
      })
      .catch(error => {
        throw error
      })
  }

  const loadPrefetched = prefetchedSchemaData => {
    cachedSchemas = prefetchedSchemaData
    schemasPromise = Promise.resolve(cachedSchemas)
    return schemasPromise
  }

  const loadSchemas = collectionNames => {
    if (schemasPromise) {
      throw new Error('Do not call loadSchemas more than once')
    }
    schemasPromise = fetchSchemas(collectionNames)
    return schemasPromise
  }

  const waitForSchemas = () => schemasPromise

  return {
    loadSchemas,
    loadPrefetched,
    waitForSchemas,
    getSchema: collectionName => getSchema(cachedSchemas, collectionName),
    getReferencedCollectionsSchemas: collectionName =>
      getReferencedCollectionsSchemas(cachedSchemas, collectionName)
  }
}

const getSchema = (schemas, collectionName) =>
  schemas ? schemas[collectionName] : null

const getReferencedCollectionsSchemas = (schemas, collectionName) => {
  const mainSchema = schemas ? schemas[collectionName] : null
  const referencedCollectionsNames = mainSchema
    ? getReferencedCollectionsNames(mainSchema)
    : null
  const referencedCollectionsSchemas =
    referencedCollectionsNames && schemas
      ? pick_(schemas, referencedCollectionsNames)
      : null

  return referencedCollectionsSchemas
}
